module.exports = __webpack_public_path__ + "static/img/CA@2x.99786525.jpg";